import { Mg2Action } from "./Mg2Action";
import { Auth0ClientInstance } from "../plugins/auth/Auth0ClientInstance";
export class LogoutAction extends Mg2Action {
    constructor() {
        super(...arguments);
        this.actionName = "logout";
    }
    run() {
        Auth0ClientInstance.logout();
    }
}
